<form [formGroup]="form" (ngSubmit)="onSave(false)" class="formgrid grid">

  <div class="col-8">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Page name</h3>
    <input pInputText formControlName="title" type="text" class="inputfield w-full"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('title')?.invalid && form.get('title')?.touched }"
      placeholder="Funeral FAQs — costs, cremation, arranging | Picaluna" />
    <small class="block text-500 mt-1">Also the browser-tab title and the search-result headline.</small>
  </div>

  <div class="col-4">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Address</h3>
    <input pInputText formControlName="path" type="text" class="inputfield w-full font-mono"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('path')?.invalid && form.get('path')?.touched, 'surface-100': page.locked }"
      placeholder="/faq" />
    <small *ngIf="page.locked" class="block text-500 mt-1">
      <i class="pi pi-lock mr-1" style="font-size: 0.7rem"></i>
      Part of the live sitemap — can't be changed.
    </small>
    <small *ngIf="!page.locked" class="block text-500 mt-1">
      Lowercase letters, numbers, dashes, slashes. Starts with /. A new address creates a new page on
      the site; changing an address that has been published leaves a redirect behind automatically.
    </small>
  </div>

  <div class="col-12">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Description <span class="text-500 text-sm font-normal">(SEO summary, ~155 chars)</span></h3>
    <textarea pInputTextarea formControlName="description" rows="2" class="inputfield w-full"
      [ngClass]="{ 'ng-invalid ng-dirty': form.get('description')?.invalid && form.get('description')?.touched }"
      placeholder="What this page is about, for search results."></textarea>
    <small class="block text-500 mt-1">Shown under the page's title in Google. Required — leaving it blank publishes an empty description.</small>
  </div>

  <!-- ── Sections ──────────────────────────────────────────────────────── -->
  <div class="col-12">
    <div class="border-bottom-1 border-200">
      <h3 class="text-500 my-2">Sections</h3>
    </div>
    <!-- The preview (#263): the block being edited, drawn by the website's own components, in a sticky column. -->
    <div class="flex gap-3 align-items-start">
      <app-content-sections-editor class="flex-1 min-w-0"></app-content-sections-editor>
      <app-block-preview *ngIf="preview.shown" [source]="previewSource" (closed)="preview.set(false)"></app-block-preview>
    </div>
  </div>

  <!-- Sticky action bar: always reachable regardless of how long the section
       list gets — adding a block and saving no longer mean scrolling to
       opposite ends of the panel. bottom offset swallows the dialog content's
       own padding so the bar sits flush while content scrolls beneath it. -->
  <div class="col-12 app-editor-action-bar flex flex-wrap align-items-center justify-content-between gap-2 surface-card border-top-1 border-200 py-3"
       style="position: sticky; bottom: -1.5rem; z-index: 5; margin-bottom: -1.5rem">
    <!-- flex-wrap + nowrap labels: at iPad width the two groups stack instead of squeezing labels onto two lines. -->
    <div class="flex flex-wrap gap-2">
      <span [pTooltip]="sectionsEditor.hasHero ? 'This page already has its hero — a page has exactly one, because it renders the page headline.' : ''"
        tooltipPosition="top">
        <button pButton pRipple type="button" label="Add hero" icon="pi pi-image"
          class="p-button-outlined p-button-sm" [disabled]="sectionsEditor.hasHero"
          (click)="sectionsEditor.addSection('editorial-hero')"></button>
      </span>
      <button pButton pRipple type="button" label="Add section" icon="pi pi-plus"
        class="p-button-outlined p-button-sm" (click)="sectionsEditor.addSection('section')"></button>
      <app-block-preview-toggle></app-block-preview-toggle>
    </div>
    <div class="flex flex-wrap align-items-center gap-4">
      <span class="flex align-items-center"
        pTooltip="When on, this version replaces the built-in page on the next publish." tooltipPosition="top">
        <p-inputSwitch class="flex-initial" formControlName="published"></p-inputSwitch>
        <span class="ml-2 text-700">Published</span>
      </span>
      <span class="flex align-items-center"
        pTooltip="Adds noindex — the page stays on the site but is hidden from Google." tooltipPosition="top">
        <p-inputSwitch class="flex-initial" formControlName="noindex"></p-inputSwitch>
        <span class="ml-2 text-700">Hide from search</span>
      </span>
      <span class="flex gap-2 align-items-center">
        <span *ngIf="lastSavedAt && !saving" class="text-600 text-sm">Saved {{ lastSavedAt | date: 'shortTime' }}</span>
        <button pButton pRipple type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
        <button pButton pRipple type="submit" label="Save" icon="pi pi-check" class="p-button-outlined"
          [loading]="saving && !closing" [disabled]="saving" data-testid="page-save"></button>
        <button pButton pRipple type="button" label="Save & Close" icon="pi pi-check"
          [loading]="saving && closing" [disabled]="saving" (click)="onSave(true)" data-testid="page-save-close"></button>
      </span>
    </div>
  </div>

</form>
